<nz-form-label [nzFor]="formFieldInfo.fieldCode" [hidden]="hideTitle" nzNoColon>
    <span>{{name}} <span *ngIf="formFieldInfo.isRequired" style="color:red;">(*)</span></span>
    <app-component-tooltip [formFieldInfo]="fieldDataInfo"></app-component-tooltip>
</nz-form-label>
<nz-form-control style="width:100%" [formGroup]="formGroup">
    <span style="width: 100%;">
        <span style="display:flex;" *ngIf="validatorOSBField();else elseif">
            <input nz-input type="text" [attr.id]="formFieldInfo.fieldCode" [attr.maxlength]="maxlength"
                (keydown)="keydownPattern($event)" nzSize="large" (change)="onchangePattern($event)"
                [formControlName]="formFieldInfo.fieldCode" [(ngModel)]="value" (ngModelChange)="modelChange()">
            <button nz-button (click)="clickSearchReloadButton()">
                <span nz-icon nzType="search"></span>
            </button>
            <span *ngIf="isRefresh">
                <button nz-button (click)="clickSearchReloadButton()">
                    <span nz-icon nzType="reload"></span>
                </button>
            </span>
        </span>
        <ng-template #elseif>
            <span style="display:flex;" *ngIf="validatorAOField();else elseother">
                <input nz-input type="text" [attr.id]="formFieldInfo.fieldCode" [attr.maxlength]="maxlength"
                    (keydown)="keydownPattern($event)" nzSize="large" (change)="onchangePattern($event)"
                    [formControlName]="formFieldInfo.fieldCode" [(ngModel)]="value" (ngModelChange)="modelChange()">
                <button *ngIf="!defaultValue" nz-button (click)="clickSearchReloadButton()">
                    <span nz-icon nzType="search"></span>
                </button>
                <button *ngIf="defaultValue" nz-button (click)="clickSearchReloadButton()">
                    <span nz-icon nzType="edit"></span>
                </button>
            </span>
            <ng-template #elseother>
                <input nz-input type="text" [attr.id]="formFieldInfo.fieldCode" [attr.maxlength]="maxlength"
                    nzSize="large" (keydown)="keydownPattern($event)" (change)="onchangePattern($event)"
                    [formControlName]="formFieldInfo.fieldCode" [(ngModel)]="value" (ngModelChange)="modelChange()">
            </ng-template>
        </ng-template>
    </span>
</nz-form-control>